import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const EmpresaPage = lazy(() => import('../pages/empresa/page'));
const ServiciosPage = lazy(() => import('../pages/servicios/page'));
const FaqPage = lazy(() => import('../pages/faq/page'));
const ContactoPage = lazy(() => import('../pages/contacto/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/empresa',
    element: <EmpresaPage />,
  },
  {
    path: '/servicios',
    element: <ServiciosPage />,
  },
  {
    path: '/faq',
    element: <FaqPage />,
  },
  {
    path: '/contacto',
    element: <ContactoPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;